module.exports = __webpack_public_path__ + "static/media/ruby.243dcd7c.mp3";